import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/user/list',
    method: 'post',
    data: JSON.stringify(data)
  })
}
export function deleteUser(id) {
  return request({
    url: '/user/delete/' + id,
    method: 'get'
  })
}
export function addEditUser(url, data) {
  return request({
    url,
    method: 'post',
    data: JSON.stringify(data)
  })
}
export function editPassword(id, newWord, oldWord) {
  return request({
    url: '/user/password/' + id + '/' + newWord + '/' + oldWord,
    method: 'post'
  })
}
export function loginOut() {
  return request({
    url: '/sys/logout',
    method: 'get'
  })
}
export function loginInfo() {
  return request({
    url: '/user/login-info',
    method: 'get'
  })
}
export function listProject(data) {
  return request({
    url: '/oa/listProject',
    method: 'post',
    data: JSON.stringify(data)
  })
}
export function listWorkOrderCountByStatus(name) {
  return request({
    url: `/oa/listWorkOrderCountByStatus/MONTH/${name}`,
    method: 'get'
  })
}
// 重置密码
export function restPassword(id) {
  return request({
    url: `/user/rest-password/${id}`,
    method: 'get'
  })
}
